import { styled, Typography } from "@mui/material";

export const MessageText = styled(Typography)({
  fontFamily: "Inter",
  fontSize: 13,
  fontWeight: 400,
  lineHeight: 1.4,
  whiteSpace: "pre-wrap",
  wordWrap: "break-word",
  overflowWrap: "break-word",
});
